<div class="landing">
  <div class="landing-card br-card br-card-body">
    <div class="brand">OptixWay</div>
    <p class="tagline">Route planning &amp; fleet operations for waste management.</p>
    <div class="actions">
      <button type="button" class="br-btn br-btn--primary" (click)="login()">Log in</button>
      <!-- Temporarily disabled while self-service tenant signup is closed.
      <button type="button" class="br-btn br-btn--outline-secondary" (click)="createAccount()">Create account</button>
      -->
    </div>
  </div>
</div>
